import { Stack } from "@mui/material";
import ImageTable from "./ImageTable";
import ReportSelector from "./ReportSelector";
import { useEffect, useState } from "react";
import ReportSelector3 from "./ReportsSelector3";
import { useUser } from "../Contexts/UserContext";
import ThreeDotLoader from "./ThreeDotLoader";
import ImageTable3 from "./ImageTable3";
import WashRoomChecklist from "./WashRoomCheckList";
import HourGroupedTable from "./HourGroupedTable";
import HourGroupedTable2 from "./HourGroupedTable2";
import getTodayDate from "./TodaysDate";
import ReportSelector6 from "./ReportSelector6";
import DynamicTable2 from "./DynamicTable2";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const columns = [
  { header: "Unit Name", field: "UnitName" },
  { header: "Unit Code", field: "UnitCode" },
  { header: "Emp Name", field: "UserName" },
  { header: "Date", field: "CreatedDate" },
];

const data = [
  { empName: "John Doe", department: "HR", pdfFile: "1739534914885.pdf" },
  { empName: "Jane Smith", department: "IT", pdfFile: "1739534914885.pdf" },
  {
    empName: "Mike Johnson",
    department: "Finance",
    pdfFile: "1739534914885.pdf",
  },
];
const FieldOfficerVisit = () => {
  const [selectedData, setSelectedData] = useState({
    branchObj: null,
    unitObj: null,
    reportObj: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState(getTodayDate());
  const [toDate, setToDate] = useState(getTodayDate());
  const [tableData, setTableData] = useState([]);
  const [reportsDD, setReportsDD] = useState([]);
  const { user } = useUser();
  const { ClientId, CompCode } = user;
  useEffect(() => {
    const fetchInitData = async () => {
      const response = await fetch(
        `https://www.apsgroupapp.com/ExpressAPI/facility/getFacilityReport?action=getFacilityChecklist&unitcode=UNTPFS00009098&clientCode=${ClientId}`
      ).then((res) => res.json());
      console.log(response);
      if (response.success) {
        setReportsDD(response.data);
      } else {
        // alert(response.message);
      }
    };
    fetchInitData();
  }, []);
  const handleFetchReports = async () => {
    if (
      selectedData.unitObj == null ||
      selectedData.branchObj == null ||
      selectedData.reportObj == null
    ) {
      return;
    }
    console.log("RPT", selectedData.reportObj.Id);
    setIsLoading(true);

    try {
      const response = await fetch(
        `https://www.apsgroupapp.com/ExpressAPI/facility/getFacilityReport?action=getSubmittedRecord&unitcode=${selectedData.unitObj.UnitCode}&startdate=${fromDate}&enddate=${toDate}&empcode=${ClientId}&remark=${selectedData.reportObj.Id}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        setTableData(data.data);
      } else {
        console.error("API Error:", data.message || "Unknown error");
        alert("Failed to fetch reports.");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      alert("An error occurred while fetching reports. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div style={{ padding: "2rem 4rem" }}>
        <ReportSelector6
          title="VIEW PDF REPORTS"
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          toDate={toDate}
          setToDate={setToDate}
          fromDate={fromDate}
          setFromDate={setFromDate}
          handleFetchReports={() => handleFetchReports()}
          reportTypeList={reportsDD}
        />
        {isLoading ? (
          <span>Loading...</span>
        ) : (
          <DynamicTable2
            columns={columns}
            data={tableData}
            pdfColumn="DocumentName"
            apiEndpoint="https://www.apsgroupapp.com/ExpressAPI/facility/download"
          />
        )}
      </div>
    </>
  );
};
export default FieldOfficerVisit;
